import React from 'react'
import WMSLayer from '../Leaflet/WMSLayer'

export default () => (
	<WMSLayer
		url = "/maps/ortofoto/wms/v1.3?"
		layers = "Ortofoto_0.16,Ortofoto_0.25,Ortofoto_0.4,Ortofoto_0.5"
	/>
)


// WEBPACK FOOTER //
// ./src/components/Map/OrtofotoWMSLayer.js